// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC3z73EF3KXwnb5ie1fXiZqbJKJNQRCFU8",
  authDomain: "aptixmvp.firebaseapp.com",
  projectId: "aptixmvp",
  storageBucket: "aptixmvp.firebasestorage.app",
  messagingSenderId: "544843584053",
  appId: "1:544843584053:web:839d2e63afac5274ef977c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, googleProvider, db }